var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen w-screen tt-bg-lightgray"})
}
var staticRenderFns = []

export { render, staticRenderFns }